import { IsUUID, IsNotEmpty, IsArray } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'

/**
 * DTO for batch lookup of program competencies by IDs
 */
export class ProgramCompetencyLookupDto {
  @ApiProperty({
    description: 'List of ProgramCompetency UUIDs to lookup',
    type: [String],
    example: ['550e8400-e29b-41d4-a716-446655440000'],
  })
  @IsArray()
  @IsUUID('4', { each: true })
  @IsNotEmpty()
  ids!: string[]
}
